import { useCallback, useEffect, useState } from 'react';
import { useListAppsQuery } from '../api/queries';
import computeInstallStatus from '../functions/computeAppInstallStatus';
import { filterInstalledApps } from '../functions/filterAppsByInstallStatus';
import getAppsOnDevice from '../functions/getApps';
import injectAppIcons from '../functions/injectAppIcons';
import { AppRecord } from '../types';

const no_apps: AppRecord[] = [];

export const useAvailableApps = () => {
  const [available_apps, setAvailableApps] = useState<
    AppRecord[] | undefined
  >();

  const { apps, isLoading, ...rest } = useListAppsQuery();

  const loadApps = useCallback(async (apps: AppRecord[]) => {
    if (apps.length) {
      const [device_apps, apps_with_install_status] = await Promise.all([
        getAppsOnDevice(),
        computeInstallStatus(apps),
      ]);

      const available_apps = injectAppIcons(
        filterInstalledApps(apps_with_install_status),
        device_apps
      );

      setAvailableApps(available_apps);
    }
  }, []);

  useEffect(() => {
    loadApps(apps);
  }, [apps, loadApps]);

  return {
    apps: available_apps || no_apps,
    isLoading: isLoading || !available_apps,
    ...rest,
  };
};
